import ContentTemplate from '../../components/ContentTemplate';
import RentalsLayout from '../../components/RentalsLayout/RentalsLayout';
import { buildPrimaryPostPage } from '../../util/buildPrimaryPostPage';

const { getStaticProps, getStaticPaths, WrappedPage } =
    await buildPrimaryPostPage({
        site: 'RENTALS',
        basePath: '/rentals-network',
        LayoutComponent: RentalsLayout,
        ContentComponent: ContentTemplate,
        useBasePathForId: true,
        contentType: 'B2B',
        menuPropName: 'submenu',
    });

export { getStaticProps, getStaticPaths };
export default WrappedPage;
